import { render, staticRenderFns } from "./UserHousingTypeQuestion.vue?vue&type=template&id=08c1d382"
import script from "./UserHousingTypeQuestion.vue?vue&type=script&lang=ts"
export * from "./UserHousingTypeQuestion.vue?vue&type=script&lang=ts"
import style0 from "./UserHousingTypeQuestion.vue?vue&type=style&index=0&id=08c1d382&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports